import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/villageGlobalGallery',
        name: 'villageGlobalGallery',
        meta: { sideMenuLabel: "Galleria villaggi" },
        component: () => import("./views/villageGlobalGallery.vue")
    },
];

export default routes;